export default function ProjectBackground() {
  const globalTransformations = [
    {
      icon: 'ri-global-line',
      title: 'نمو العمل الحر والعمل عن بُعد',
      color: 'from-[#FF6B6B] to-[#FF8E53]'
    },
    {
      icon: 'ri-rocket-line',
      title: 'صعود ريادة الأعمال بين الشباب',
      color: 'from-[#FF8E53] to-[#FFB347]'
    },
    {
      icon: 'ri-building-line',
      title: 'تراجع مفهوم المكتب التقليدي',
      color: 'from-[#FFB347] to-[#FF6B6B]'
    },
    {
      icon: 'ri-lightbulb-line',
      title: 'ازدياد أهمية الابتكار المفتوح',
      color: 'from-[#FF6B6B] to-[#FF8E53]'
    }
  ];

  const challenges = [
    {
      icon: 'ri-school-line',
      title: 'الجامعات',
      description: 'مساحات غير مهيأة للطلاب'
    },
    {
      icon: 'ri-seedling-line',
      title: 'الحاضنات',
      description: 'بيئات عمل لا تفهم عقلية الشباب'
    },
    {
      icon: 'ri-hand-heart-line',
      title: 'برامج الدعم',
      description: 'غياب الدمج بين العمل + التطوير + الإلهام + الترفيه'
    }
  ];

  const opportunities = [
    {
      icon: 'ri-layout-grid-line',
      title: 'مرنة',
      description: 'تتكيف مع احتياجات المستخدمين المختلفة'
    },
    {
      icon: 'ri-flashlight-line',
      title: 'محفزة',
      description: 'بيئة ملهمة تشجع على الإبداع والابتكار'
    },
    {
      icon: 'ri-building-2-line',
      title: 'مدعومة من شركات كبرى',
      description: 'شراكات استراتيجية تضمن الاستدامة'
    },
    {
      icon: 'ri-price-tag-3-line',
      title: 'منخفضة التكلفة أو مجانية',
      description: 'متاحة للجميع دون عوائق مالية'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-white to-[#FFF5F3]">
      <div className="container mx-auto px-6 lg:px-12">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            خلفية المشروع والسياق العام
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-[#FF6B6B] to-[#FF8E53] mx-auto rounded-full"></div>
        </div>

        {/* Global Transformation */}
        <div className="mb-20">
          <div className="text-center mb-12">
            <h3 className="text-3xl font-bold text-gray-900 mb-4">
              التحول العالمي في بيئات العمل
            </h3>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              شهد العالم خلال العقد الأخير تحولات جذرية في طبيعة العمل وبيئاته
            </p>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {globalTransformations.map((item, index) => (
              <div
                key={index}
                className="group bg-white p-6 rounded-2xl border border-gray-100 hover:shadow-xl transition-all duration-300 hover:-translate-y-2"
              >
                <div className={`w-14 h-14 bg-gradient-to-br ${item.color} rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300`}>
                  <i className={`${item.icon} text-white text-2xl`}></i>
                </div>
                <p className="font-semibold text-gray-800 leading-relaxed">
                  {item.title}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* The Real Challenge - Split Screen */}
        <div className="mb-20">
          <div className="text-center mb-12">
            <h3 className="text-3xl font-bold text-gray-900 mb-4">
              التحدي الحقيقي
            </h3>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto mb-8">
              رغم كثرة المؤسسات والبرامج، إلا أن هناك فجوة حقيقية في تلبية احتياجات الشباب
            </p>
          </div>

          {/* Split Screen Layout */}
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            {/* Left Side - Image */}
            <div className="relative order-2 lg:order-1">
              <div className="relative rounded-3xl overflow-hidden shadow-2xl bg-gradient-to-br from-gray-100 to-gray-200">
                <img
                  src="/youth-challenges.png"
                  alt="التحديات التي تواجه الشباب"
                  className="w-full h-[400px] object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
                <div className="absolute bottom-6 left-6 right-6">
                  <p className="text-white font-bold text-xl drop-shadow-lg">
                    الفجوة الحقيقية في دعم المواهب الشابة
                  </p>
                </div>
              </div>
              {/* Decorative circles */}
              <div className="absolute -top-4 -right-4 w-24 h-24 bg-gradient-to-br from-[#FF6B6B]/20 to-[#FF8E53]/20 rounded-full blur-xl"></div>
              <div className="absolute -bottom-4 -left-4 w-32 h-32 bg-gradient-to-br from-[#FF8E53]/20 to-[#FFA07A]/20 rounded-full blur-xl"></div>
            </div>

            {/* Right Side - Content */}
            <div className="order-1 lg:order-2">
              <div className="space-y-6">
                {challenges.map((challenge, index) => (
                  <div
                    key={index}
                    className="relative bg-white p-6 rounded-2xl border-2 border-gray-100 hover:border-[#FF6B6B] transition-all duration-300 group"
                  >
                    <div className="flex items-start gap-4">
                      <div className="w-14 h-14 bg-gradient-to-br from-[#FF6B6B] to-[#FF8E53] rounded-xl flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform duration-300">
                        <i className={`${challenge.icon} text-white text-2xl`}></i>
                      </div>
                      <div className="flex-1">
                        <h4 className="font-bold text-lg text-gray-900 mb-2">
                          {challenge.title}
                        </h4>
                        <p className="text-gray-600 leading-relaxed text-sm">
                          {challenge.description}
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* The Opportunity */}
        <div className="relative">
          <div className="absolute inset-0 bg-gradient-to-r from-[#FF6B6B]/5 to-[#FF8E53]/5 rounded-3xl"></div>
          <div className="relative p-8 lg:p-12">
            <div className="text-center mb-12">
              <h3 className="text-3xl font-bold text-gray-900 mb-4">
                الفرصة
              </h3>
              <p className="text-xl text-gray-700 font-semibold max-w-2xl mx-auto">
                إنشاء مساحة تجمع بين المرونة والإلهام والدعم المؤسسي
              </p>
            </div>
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
              {opportunities.map((opportunity, index) => (
                <div
                  key={index}
                  className="bg-white p-6 rounded-2xl border border-gray-100 hover:shadow-lg transition-all duration-300 group"
                >
                  <div className="w-14 h-14 bg-gradient-to-br from-[#FF6B6B] to-[#FF8E53] rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300">
                    <i className={`${opportunity.icon} text-white text-2xl`}></i>
                  </div>
                  <h4 className="font-bold text-lg text-gray-900 mb-2">
                    {opportunity.title}
                  </h4>
                  <p className="text-sm text-gray-600 leading-relaxed">
                    {opportunity.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
